import './social_profile_view.js.coffee'
Namespace 'Customer.Users'

class Customer.Users.LivefyreProfileView extends Customer.Users.SocialProfileView
  template: JST['backbone/templates/customer/users/livefyre_profile']
  id: 'livefyre-profile'
